// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1M96t","right":"styles_right__wY4KS"};